import { useQuery } from "react-query";
import api from "../api";
import { API_ROUTES } from "../../utils/const";

const FETCH_ALL_REFUNDS = async (payload, headers) => {
  const response = await api.post(API_ROUTES.GET_ALL_REFUNDS, payload, headers);
  return response.data;
};

export const getAllRefundsData = (data, headers) => {
  return useQuery({
    queryKey: ["allRefunds", data, headers],
    queryFn: () => FETCH_ALL_REFUNDS(data, headers),
  });
};
